// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"29850839","703":"75729efe"}[chunkId] + ".chunk.js";
};